import React from 'react'

const MenuIcon = props => {
  return (
    <svg
      style={{ width: 32, height: 32 }}
      viewBox="0 0 31 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g transform="translate(1.000000, 0.000000)">
        <rect x="0" y="0" width="30" height="4" />
        <rect x="0" y="7" width="30" height="4" />
        <rect x="0" y="14" width="30" height="4" />
      </g>
      <path
        d="M2.086,31.5440002 L0.854,31.5440002 L0.854,21.5620002 L2.072,21.5620002 L4.074,26.3220002 L6.062,21.5620002 L7.266,21.5620002 L7.266,31.5440002 L6.034,31.5440002 L6.034,25.3000002 L6.356,22.9760002 L5.796,24.7400002 L4.27,28.2680002 L3.864,28.2680002 L2.24,24.6560002 L1.722,22.9900002 L2.086,25.3140002 L2.086,31.5440002 Z M14.594,31.5440002 L9.974,31.5440002 L9.974,21.5620002 L14.454,21.5620002 L14.454,22.7520002 L11.276,22.7520002 L11.276,25.8600002 L14.034,25.8600002 L14.034,27.0780002 L11.276,27.0780002 L11.276,30.3120002 L14.594,30.3120002 L14.594,31.5440002 Z M18.1,31.5440002 L16.896,31.5440002 L16.896,21.5620002 L18.044,21.5620002 L20.886,27.9460002 L21.488,29.6540002 L21.278,27.8340002 L21.278,21.5620002 L22.496,21.5620002 L22.496,31.5440002 L21.362,31.5440002 L18.464,25.0900002 L17.876,23.0880002 L18.1,25.2580002 L18.1,31.5440002 Z M27.766,31.6840002 C25.988,31.6840002 25.134,30.7460002 25.134,28.6880002 L25.134,21.5620002 L26.492,21.5620002 L26.492,28.6180002 C26.492,29.8780002 26.87,30.3960002 27.766,30.3960002 C28.662,30.3960002 29.026,29.8780002 29.026,28.6180002 L29.026,21.5620002 L30.384,21.5620002 L30.384,28.6880002 C30.384,30.7460002 29.488,31.6840002 27.766,31.6840002 Z"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default MenuIcon
